

















import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import IFormField from '@/modules/form/interfaces/IFormField';

@Component({
    name: 'NumericalInput',
    components: {},
})
export default class NumericalInput extends Vue {
    @Prop() public formField!: IFormField;
    private numericalValue = NaN;

    @Watch('numericalValue', { immediate: true, deep: true })
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    private onCheckedOptionsChanged(val: any[]) {
        if (val !== undefined) {
            this.formField.Value = this.numericalValue.toString();
        } else {
            console.error('numericalValue is undefined.');
        }
    }
}
